export const environment = {
  production: true,
  baseUrl: (<any>window).baseApi,
};
